/*
  OutgoingReportRequests.js - Handles Search for Customer Report Data
*/

// OUR MODULES
import RequestRabbit from './RequestRabbit';
import config from '../Config';

const useOutgoingReportRequest = () => {
  /*
    Get Report Data for Date Range
  */
  const getReportData = async (fromDate, toDate, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/report/traffic/out`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const body = JSON.stringify({
        fromDate: fromDate,
        toDate: toDate,
      });
      const options = {
        method: 'POST',
        body: body,
        headers: headers,
      };
      // Request data
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  return { getReportData };
};

export default useOutgoingReportRequest;
